import React from 'react';
import _map from 'lodash/map';
import ValueDisplay from 'components/ValueDisplay';

export default props => {
  let {object} = props;
  return (
    <div className="object-display">
      {
        _map(props.object, (value, label) => {
          if (props.filterFunc && !props.filterFunc(value, label)) {
            return;
          }
        return <ValueDisplay key={label} value={value} label={label} />
      })}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/ObjectDisplay.jsx